import React, { useContext, useReducer, useState } from "react";

import "./App.css";
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Container,
  Alert,
} from "reactstrap";
import { useBlue } from "./hooks/useBlue";
import { ctx } from "./ctx";

export function Home() {
  const [connected, setConnected] = useState(false);
  const [message, setMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const {
    data: { loading },
  } = useContext(ctx);

  const [state, setState] = useReducer(
    (state, action) => {
      switch (action.type) {
        case "update":
          return { ...state, ...action.payload };
        default:
          return state;
      }
    },
    {
      ssid: "",
      password: "",
      apiToken: "",
      zoneID: "",
      recordID: "",
      hostname: "",
    }
  );

  const blue = useBlue();

  async function connectToDeviceBluetooth() {
    try {
      await blue.connect(async () => {
        setConnected(false);
        setMessage("Bluetooth device disconnected.");
      });
      setConnected(true);
      setMessage("Connected to Bluetooth device.");
    } catch (error) {
      const msg = error instanceof Error ? error.message : String(error);
      setErrorMessage("Failed to connect to Bluetooth device. " + msg);
    }
  }

  function clearForm() {
    setState({
      type: "update",
      payload: {
        ssid: "",
        password: "",
        apiToken: "",
        zoneID: "",
        recordID: "",
        hostname: "",
      },
    });
  }

  // Handle form submission
  async function handleSubmit(event: any) {
    setErrorMessage("");
    event.preventDefault();
    if (!connected) {
      setErrorMessage("Please connect to a Bluetooth device first.");
      return;
    }

    try {
      const message = JSON.stringify({
        storedSSID: state.ssid,
        storedPassword: state.password,
        storedApiToken: state.apiToken,
        storedZoneID: state.zoneID,
        storedRecordID: state.recordID,
        storedHostname: state.hostname,
      });
      await blue.sendMessage(message);
    } catch (error) {
      const msg = error instanceof Error ? error.message : String(error);
      setErrorMessage("Failed to send data to the Bluetooth device. " + msg);
    }
  }

  return (
    <div className="App">
      <header className="App-header">
        <h3>Esp32-DDNS</h3>
      </header>
      <div className="App-content">
        <Container>
          {errorMessage && <Alert color="danger">{errorMessage}</Alert>}
          {message && <Alert color="success">{message}</Alert>}
          {loading && <p>Loading...</p>}

          <Form>
            <FormGroup>
              <Label for="ssid">SSID</Label>
              <Input
                id="ssid"
                name="ssid"
                placeholder="Enter your WiFi SSID"
                type="text"
                value={state.ssid}
                onChange={(e) =>
                  setState({
                    type: "update",
                    payload: { ssid: e.target.value },
                  })
                }
              />
            </FormGroup>
            <FormGroup>
              <Label for="password">Password</Label>
              <Input
                id="password"
                name="password"
                placeholder="Enter your WiFi password"
                type="password"
                value={state.password}
                onChange={(e) =>
                  setState({
                    type: "update",
                    payload: { password: e.target.value },
                  })
                }
              />
            </FormGroup>
            <FormGroup>
              <Label for="apiToken">Cloudflare API Token</Label>
              <Input
                id="apiToken"
                name="apiToken"
                placeholder="Enter your Cloudflare API token"
                type="text"
                value={state.apiToken}
                onChange={(e) =>
                  setState({
                    type: "update",
                    payload: { apiToken: e.target.value },
                  })
                }
              />
            </FormGroup>
            <FormGroup>
              <Label for="zoneID">Zone ID</Label>
              <Input
                id="zoneID"
                name="zoneID"
                placeholder="Enter your Cloudflare Zone ID"
                type="text"
                value={state.zoneID}
                onChange={(e) =>
                  setState({
                    type: "update",
                    payload: { zoneID: e.target.value },
                  })
                }
              />
            </FormGroup>
            <FormGroup>
              <Label for="recordID">Record ID</Label>
              <Input
                id="recordID"
                name="recordID"
                placeholder="Enter your DNS Record ID"
                type="text"
                value={state.recordID}
                onChange={(e) =>
                  setState({
                    type: "update",
                    payload: { recordID: e.target.value },
                  })
                }
              />
            </FormGroup>
            <FormGroup>
              <Label for="hostname">Hostname</Label>
              <Input
                id="hostname"
                name="hostname"
                placeholder="Enter your hostname (e.g., example.com)"
                type="text"
                value={state.hostname}
                onChange={(e) =>
                  setState({
                    type: "update",
                    payload: { hostname: e.target.value },
                  })
                }
              />
            </FormGroup>
            <Row className="gap-3 p-3">
              {!connected && (
                <Alert color="info">
                  ensure that the ESP32 is powered. press Reset Button on the
                  ESP32 for 5 seconds to clear the configuration. After that,
                  you can connect to the ESP32 using Bluetooth and submit the
                  form. The ESP32 will then update its configuration with the
                  provided data and restart to apply the new settings.
                </Alert>
              )}
            </Row>
            <Row className="gap-3 p-3">
              <Button
                onClick={connectToDeviceBluetooth}
                color="primary"
                disabled={connected}
              >
                Connect to ESP32
              </Button>
              <Button
                disabled={!connected}
                onClick={handleSubmit}
                type="submit"
                color="success"
              >
                Submit Data
              </Button>

              <br />

              <Button
                disabled={loading}
                onClick={clearForm}
                color="warning"
                type="submit"
                className="btn btn-primary"
              >
                Clear Form
              </Button>
            </Row>
          </Form>
        </Container>
      </div>
    </div>
  );
}
